// SERVER URL & STORAGE
export const BASE_URL = "https://beta.hottel.io";
export const BASE_ASSETS_URL = "https://beta-assets.hottel.io";

// ENDPOINTS - auth
export const SIGN_IN = "/api/v1/auth/signin";
export const SIGN_UP = "/api/v1/auth/signup";
export const FORGET_PASSWORD = "/api/v1/auth/forgot-password";
export const USER_LOGGED_IN = "/api/v1/auth/me";
export const LOGOUT = "/api/v1/auth/logout";